export const orgMap: Record<string, string> = {
  nfl: 'NFL',
  ari: 'Cardinals',
  atl: 'Falcons',
  bal: 'Ravens',
  buf: 'Bills',
  car: 'Panthers',
  chi: 'Bears',
  cin: 'Bengals',
  cle: 'Browns',
  dal: 'Cowboys',
  den: 'Broncos',
  det: 'Lions',
  gbp: 'Packers',
  hou: 'Texans',
  ind: 'Colts',
  jax: 'Jaguars',
  kcc: 'Chiefs',
  lvr: 'Raiders',
  lac: 'Chargers',
  lar: 'Rams',
  mia: 'Dolphins',
  min: 'Vikings',
  nep: 'Patriots',
  nos: 'Saints',
  nyg: 'Giants',
  nyj: 'Jets',
  phi: 'Eagles',
  pit: 'Steelers',
  sfr: '49ers',
  sea: 'Seahawks',
  tbb: 'Buccaneers',
  ten: 'Titans',
  was: 'Commanders',
};
